var render, staticRenderFns
import script from "./company_body.vue?vue&type=script&lang=js"
export * from "./company_body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91ecdd2e')) {
      api.createRecord('91ecdd2e', component.options)
    } else {
      api.reload('91ecdd2e', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/company_body/company_body.vue"
export default component.exports